import React from 'react';
import TreatmentsTemplate from '../treatmentsTemplate/TreatmentsTemplate';

const pageTitle = 'Cortisone Injection';
const pageSubTitle = 'What are corticosteroid injections?';
const pageDescription = 'Corticosteroid injections are an anti-inflammatory that can be injected into the knee joint to reduce pain and swelling';
const videoKey = 'Ej4JR35rE0k';

const resourceLinks = [
    {
        title: 'Cortisone Injections',
        link: 'https://mydoctor.kaiserpermanente.org/mas/structured-content/Procedure_Cortisone_Injections_-_PMR.xml?co=%2Fregions%2Fmas',
    },
    {
        title: 'Arthritis: Shots for Knee Pain',
        link: 'https://healthy.kaiserpermanente.org/health-wellness/health-encyclopedia/he.arthritis-shots-for-knee-pain.abq4711',
    },
    {
        title: 'Joint Injections: Care Instructions',
        link: 'https://healthy.kaiserpermanente.org/health-wellness/health-encyclopedia/he.joint-injections-care-instructions.ad1775',
    },
    {
        title: 'What to Know about Joint Injections for Arthritis',
        link: 'https://mydoctor.kaiserpermanente.org/mas/news/what-to-know-about-joint-injections-for-arthritis-2645467',
    },
    {
        title: 'Learning About Joint Injections',
        link: 'https://healthy.kaiserpermanente.org/health-wellness/health-encyclopedia/he.learning-about-joint-injections.abs2710',
    },
];

const CortisoneInjection = () => {
    return (
        <TreatmentsTemplate
            pageTitle={pageTitle}
            pageSubTitle={pageSubTitle}
            pageDescription={pageDescription}
            videoKey={videoKey}
            resourceLinks={resourceLinks}
            pageType="treatment"
        />
    );
};

export default CortisoneInjection;